import React from 'react';

import { Route } from 'circe/routing/provider';
import { AUTHORITIES } from 'domain/fuse/auth/constants';
import RequireAuth from 'circe/authorization/components/AuthorizationRoute';
import { loadComponent } from 'domain/layout/utils';
import { ROUTES } from 'domain/vehicle/components/updateInfo/constants';

const updateVehicleInfoContainer = loadComponent(() => import('./container'));

const authorizedUpdateVehicleContainer = RequireAuth(
  updateVehicleInfoContainer,
  [
    AUTHORITIES.OPERATOR,
    AUTHORITIES.ACCOUNT_ADMIN,
    AUTHORITIES.ACCOUNT_ADMIN_COURIER,
    AUTHORITIES.SHIPPER_SFS,
  ],
  '/search',
);

export default () => (
  <Route exact path={ROUTES.ROOT} key={ROUTES.ROOT} component={authorizedUpdateVehicleContainer} />
);
